export const SET_PRICES = "SET_PRICES";

export const GET_PRICES = "GET_PRICES";
